module.exports = __webpack_public_path__ + "img/books.af0de0df.jpg";